import { injectable, injectFromBase } from 'inversify'
import { DomainSettings } from '@/decorators/domainDecorators'
import DomainBaseService from '@/services/domain/domainBaseService'
import SenderIdPrice from '@/data/models/domain/senderId/SenderIdPrice'
import type SenderIdPriceRepository from '@/data/repositories/domain/services/senderIdPriceRepository'

@DomainSettings({
  model: SenderIdPrice,
})
@injectable()
@injectFromBase()
export default class SenderIdPriceService extends DomainBaseService<SenderIdPriceRepository> {
  public fillPriceDetails() {
    return this.getDomainRepository().fillPriceDetails()
  }

  public getPriceDetails() {
    return this.getDomainRepository().getPriceDetails()
  }
}
